import React, { Suspense } from 'react';

const Survey = React.lazy(() => import('./Survey'));

export default function SurveyHost({ style = {} }) {
    return (
        <div className="w-100" style={style}>
            <Suspense fallback={<div className="align-content-center align-self-center">Lädt...</div>}>
                <Survey />
            </Suspense>
        </div>
    );
}
